module.exports = __webpack_public_path__ + "static/media/chihuahua.a2329e60.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/chihuahua.jpg
// module id = 99
// module chunks = 0